/* eslint-disable */

/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
    var registeredInModuleLoader = false;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    if (typeof exports === 'object') {
        module.exports = factory();
        registeredInModuleLoader = true;
    }
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function () {
            window.Cookies = OldCookies;
            return api;
        };
    }
}(function () {
    function extend () {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
            var attributes = arguments[ i ];
            for (var key in attributes) {
                result[key] = attributes[key];
            }
        }
        return result;
    }

    function init (converter) {
        function api (key, value, attributes) {
            var result;
            if (typeof document === 'undefined') {
                return;
            }

            // Write

            if (arguments.length > 1) {
                attributes = extend({
                    path: '/'
                }, api.defaults, attributes);

                if (typeof attributes.expires === 'number') {
                    var expires = new Date();
                    expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
                    attributes.expires = expires;
                }

                try {
                    result = JSON.stringify(value);
                    if (/^[\{\[]/.test(result)) {
                        value = result;
                    }
                } catch (e) {}

                if (!converter.write) {
                    value = encodeURIComponent(String(value))
                        .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                } else {
                    value = converter.write(value, key);
                }

                key = encodeURIComponent(String(key));
                key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                key = key.replace(/[\(\)]/g, escape);

                return (document.cookie = [
                    key, '=', value,
                    attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                    attributes.path ? '; path=' + attributes.path : '',
                    attributes.domain ? '; domain=' + attributes.domain : '',
                    attributes.secure ? '; secure' : ''
                ].join(''));
            }

            // Read

            if (!key) {
                result = {};
            }

            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling "get()"
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var rdecode = /(%[0-9A-Z]{2})+/g;
            var i = 0;

            for (; i < cookies.length; i++) {
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');

                if (cookie.charAt(0) === '"') {
                    cookie = cookie.slice(1, -1);
                }

                try {
                    var name = parts[0].replace(rdecode, decodeURIComponent);
                    cookie = converter.read ?
                        converter.read(cookie, name) : converter(cookie, name) ||
                        cookie.replace(rdecode, decodeURIComponent);

                    if (this.json) {
                        try {
                            cookie = JSON.parse(cookie);
                        } catch (e) {}
                    }

                    if (key === name) {
                        result = cookie;
                        break;
                    }

                    if (!key) {
                        result[name] = cookie;
                    }
                } catch (e) {}
            }

            return result;
        }

        api.set = api;
        api.get = function (key) {
            return api.call(api, key);
        };
        api.getJSON = function () {
            return api.apply({
                json: true
            }, [].slice.call(arguments));
        };
        api.defaults = {};

        api.remove = function (key, attributes) {
            api(key, '', extend(attributes, {
                expires: -1
            }));
        };

        api.withConverter = init;

        return api;
    }

    return init(function () {});
}));

/* Cookie banner */
var CookieBanner = (function (window, document, $) {
    var KOPIOSTO_COOKIE_KEY = "kopiosto_cookie_notification";
    var $cookieBanner;

    var now = new Date();
    var time = now.getTime();
    var expireTime = time + 1000*36000;
    now.setTime(expireTime);

    function init() {
        $cookieBanner = $('.js-cookie-banner');
        if ($('.js-edit-cookies')) {
            $('.js-edit-cookies').on('click', openCookieModal);
        }
        if ($cookieBanner.length === 0 || hasSeenBanner()) {
            // initFromCookies();
            return;
        }
        $('.js-allow-cookies').on('click', allowAllCookies);
        $('.js-necessary-cookies').on('click', useNecessaryCookiesOnly);
        $('.js-open-cookie-modal').on('click', openCookieModal);
        $cookieBanner.delay(1000).fadeIn('fast');
    }

    function hasSeenBanner() {
        return Cookies.get(KOPIOSTO_COOKIE_KEY) === "true";
    }

    function initFromCookies() {
        /*
        if (Cookies.get('cookie-ads') == "granted"){
            gtag('consent', 'update', {'ad_storage': 'granted'});
        } else {
            gtag('consent', 'update', {'ad_storage': 'denied'});
        }

        if (Cookies.get('cookie-analytics') == "granted"){
            gtag('consent', 'update', {'analytics_storage': 'granted'});
        } else {
            gtag('consent', 'update', {'analytics_storage': 'denied'});
        }

        if (Cookies.get('cookie-functional') == "granted"){
            // No need to do anything
        } else {
            Cookies.remove("pll_language");
        }
        */
    }

    // Allow all
    function allowAllCookies() {

        hideAndDisableCookieBanner();
        showNewsletterModal();

        // Call the update command when your consent status changes
        // (e.g. after a visitor grants consent). Modify the updates per
        // your business requirements and what consent is granted, e.g.:
        gtag('consent', 'update', {'ad_storage': 'granted', 'analytics_storage': 'granted'});

        Cookies.set("cookie-ads", "granted", { expires: 365 });
        Cookies.set("cookie-analytics", "granted", { expires: 365 });
        Cookies.set("cookie-functional", "granted", { expires: 365 });
    }

    // Use necessary
    function useNecessaryCookiesOnly() {
        hideAndDisableCookieBanner();
        showNewsletterModal();

        gtag('consent', 'update', {'ad_storage': 'denied', 'analytics_storage': 'denied'});

        // Save cookie consent status
        Cookies.set("cookie-ads", "denied", { expires: 365 });
        Cookies.set("cookie-analytics", "denied", { expires: 365 });
        Cookies.set("cookie-functional", "denied", { expires: 365 });

        Cookies.remove("pll_language");
    }

    // Cookie modal
    function openCookieModal() {
        var cookieModalBody = $('.cookie-modal__body');

        $('.js-cookie-modal').show();
        hideAndDisableCookieBanner();

        // Check if line-clamp is used
        if (cookieModalBody[0].scrollHeight > cookieModalBody[0].clientHeight) {
            $('.cookie-modal__show-more').show();

            $(".cookie-modal__show-more" ).on( "click", function() {
                cookieModalBody.css("display", "block");
                $('.cookie-modal__show-more').hide();
            });
        }

        // Init selected from cookies
        if (Cookies.get('cookie-ads') == "granted"){
            $(".js-cookie-group input:checkbox[value=ad_storage]").prop('checked', true);
            $(".js-cookie-group input:checkbox[value=ad_storage]").parents('.accordion__sub-title').addClass('js-group-toggle--selected');
        }

        if (Cookies.get('cookie-analytics') == "granted"){
            $(".js-cookie-group input:checkbox[value=analytics_storage]").prop('checked', true);
            $(".js-cookie-group input:checkbox[value=analytics_storage]").parents('.accordion__sub-title').addClass('js-group-toggle--selected');
        }

        if (Cookies.get('cookie-functional') == "granted"){
            $(".js-cookie-group input:checkbox[value=functional_storage]").prop('checked', true);
            $(".js-cookie-group input:checkbox[value=functional_storage]").parents('.accordion__sub-title').addClass('js-group-toggle--selected');
        }

        // Save button
        $( ".js-save-cookie-modal" ).on( "click", function() {

            $(".js-cookie-group input:checkbox[name=group]").each(function(){

                if ($(this).val() === 'ad_storage') {
                    if ($(this).prop('checked') == true) {
                        gtag('consent', 'update', {'ad_storage': 'granted'});
                        Cookies.set("cookie-ads", "granted", { expires: 365 });
                    } else {
                        gtag('consent', 'update', {'ad_storage': 'denied'});
                        Cookies.set("cookie-ads", "denied", { expires: 365 });
                        Cookies.remove('_ga', { path: '/', domain: location.hostname.replace(/^www\./i, "") });
                        Cookies.remove('_gid', { path: '/', domain: location.hostname.replace(/^www\./i, "") });
                    }
                }

                if ($(this).val() === 'analytics_storage') {
                    if ($(this).prop('checked') == true) {
                        gtag('consent', 'update', {'analytics_storage': 'granted'});
                        Cookies.set("cookie-analytics", "granted", { expires: 365 });
                    } else {
                        gtag('consent', 'update', {'analytics_storage': 'denied'});
                        Cookies.set("cookie-analytics", "denied", { expires: 365 });
                        Cookies.remove('_ga', { path: '/', domain: location.hostname.replace(/^www\./i, "") });
                        Cookies.remove('_gid', { path: '/', domain: location.hostname.replace(/^www\./i, "") });
                    }
                }

                if ($(this).val() === 'functional_storage') {
                    if ($(this).prop('checked') == true) {
                        Cookies.set("cookie-functional", "granted", { expires: 365 });
                    } else {
                        Cookies.remove("pll_language");
                        Cookies.set("cookie-functional", "denied", { expires: 365 });
                    }
                }
            });

            $('.js-cookie-modal').fadeOut('fast');
        });

        $( ".js-allow-cookie-modal" ).on( "click", function() {
            $(".js-cookie-group input:checkbox[name=group]").each(function(){
                $(this).prop( "checked", true );
            });
            gtag('consent', 'update', {'ad_storage': 'granted', 'analytics_storage': 'granted'});
            Cookies.set("cookie-ads", "granted", { expires: 365 });
            Cookies.set("cookie-analytics", "granted", { expires: 365 });
            Cookies.set("cookie-functional", "granted", { expires: 365 });
            $('.js-cookie-modal').fadeOut('fast');
        });

        $( ".js-continue-cookie-modal" ).on( "click", function() {
            $(".js-cookie-group input:checkbox[name=group]").each(function(){
                $(this).prop( "checked", false );
            });
            gtag('consent', 'update', {'ad_storage': 'denied', 'analytics_storage': 'denied'});
            Cookies.set("cookie-ads", "denied", { expires: 365 });
            Cookies.set("cookie-analytics", "denied", { expires: 365 });
            Cookies.set("cookie-functional", "denied", { expires: 365 });
            Cookies.remove("pll_language");
            $('.js-cookie-modal').fadeOut('fast');
        });

        // Close button
        $( ".js-toggle-cookie-modal" ).on( "click", function() {
            $('.js-cookie-modal').fadeOut('fast');
        });
    }

    function hideAndDisableCookieBanner() {
        Cookies.set(KOPIOSTO_COOKIE_KEY, "true", { expires: 365 });
        $cookieBanner.fadeOut('fast');
    }

    function showNewsletterModal() {
        $('.js-newsletter-modal').delay(2000).fadeIn('fast');
        $('.js-newsletter-modal-backdrop').delay(1900).fadeIn('fast');
    }

    return {
        init: init
    };
})(window, document, jQuery);

/* Newsletter modal */
var NewsletterModal = (function (window, document, $) {
  var KOPIOSTO_NEWSLETTER_KEY = "kopiosto_newsletter_notification";
  var $newsletterModal;
  var $newsletterModalBackdrop;

  // Build cookie key prefix from attribute or a class starting with "avek"
  function getKeyPrefix() {
    var attr = $newsletterModal.attr("avek");
    if (attr && String(attr).trim()) return String(attr).trim();
    var cls = ($newsletterModal.attr("class") || "")
      .split(/\s+/)
      .find(function (c) { return /^avek/.test(c); });
    return cls || "";
  }

  function init() {
    $newsletterModal = $('.js-newsletter-modal[avek]:not([avek=""]), .js-newsletter-modal[class^="avek"]');
    $('.js-newsletter-modal[avek=""]').hide();
    $newsletterModalBackdrop = $('.js-newsletter-modal-backdrop');

    if ($newsletterModal.length === 0 || hasSeenBanner()) return;

    $('.js-newsletter-modal').not($newsletterModal).hide();

    $newsletterModal.delay(2000).fadeIn('fast');
    $newsletterModalBackdrop.delay(1900).fadeIn('fast');

    $newsletterModal.find('.js-toggle-newsletter-modal').on('click', function () {
      Cookies.set(getKeyPrefix() + KOPIOSTO_NEWSLETTER_KEY, "true", { expires: 365 });
      $newsletterModal.fadeOut('fast');
      $newsletterModalBackdrop.fadeOut('fast');
    });
  }

  function hasSeenBanner() {
    return Cookies.get(getKeyPrefix() + KOPIOSTO_NEWSLETTER_KEY) === "true";
  }

  return { init: init };
})(window, document, jQuery);

export {
    CookieBanner,
    NewsletterModal
}

/* eslint-enable */
